window.vf.enterprisePopup = (function () {
    'use strict';

    var modalsToInject = [
        {
            'sites': [
                '/simplicity/pages/enterprise-only/enterprise-popup/business.html',
                '/simplicity/pages/enterprise-only/enterprise-popup/enterprise.html'
            ],
            'stdModalId': 'googlePopup',
            'stdTriggerLink': 'google.de',
            'stdHeadline': 'Mit dem IoT-Weltmarktführer die neusten Trends der Prozessoptimierung erleben',
            'stdSubline': 'Unser Newsletter informiert Sie monatlich zu Themen wie IoT und aktuellen Trends im digitalen Business - natürlich kostenlos',
            'stdTeaser': '/simplicity/components/enterprise-modal/assets/formular_verteiler.png',
            /* 'stdDelay': 5000, */
            'buttons': [
                {
                    'stdLabel': 'Jetzt Newsletter abonnieren',
                    'stdLink': '//www.google.de',
                    'stdButtonClass': 'btn-red'
                },
                {
                    'stdLabel': 'Button text',
                    'stdLink': '//www.google.de',
                    'stdButtonClass': 'btn-primary'
                }
            ]
        },
        {
            'sites': [
                '/simplicity/pages/enterprise-only/enterprise-popup/delayed/*'
            ],
            'stdModalId': 'vodafonePopup',
            'stdTriggerLink': 'eweb8.vfd2-testnet.de/business/digitalisierung/branchenloesungen.html',
            'stdHeadline': 'Mit dem IoT-Weltmarktführer die neusten Trends der Prozessoptimierung erleben',
            'stdSubline': 'Unser Newsletter informiert Sie monatlich zu Themen wie IoT und aktuellen Trends im digitalen Business - natürlich kostenlos',
            'stdTeaser': '/simplicity/components/enterprise-modal/assets/formular_verteiler.png',
            'stdDelay': 5000,
            'buttons': [
                {
                    'stdLabel': 'Jetzt Newsletter abonnieren',
                    'stdLink': '//www.google.de',
                    'stdButtonClass': 'btn-red'
                },
                {
                    'stdLabel': 'Button text',
                    'stdLink': '//www.google.de',
                    'stdButtonClass': 'btn-primary'
                }
            ]
        },
        /* {
            'sites': [
                '/business/loesungen/smart-health.html'
            ],
            'blacklist': [

            ],
            'stdModalId': 'smartHealthPopup',
            'stdTriggerLink': 'eweb8.vfd2-testnet.de/business/digitalisierung/branchenloesungen.html',
            'stdHeadline': 'Whitepaper: So verändert eHealth die Medizin',
            'stdSubline': 'Lesen Sie in unserem Whitepaper, wie Sie die Qualität medizinischer Versorgung verbessern und die Effizienz steigern können. Und welche Rolle 5G dabei spielt.',
            'stdTeaser': '/simplicity/components/enterprise-popup/assets/ehealth-whitepaper-popup-652x280-dt.jpg',
            'stdDelay': 10000,
            'buttons': [
                {
                    'stdLabel': 'Zum Whitepaper Download',
                    'stdLink': 'https://eweb8.vfd2-testnet.de/business/loesungen/whitepaper-ehealth.html?icmp=vbg:popup-ehealth-wp',
                    'stdButtonClass': 'btn-red'
                },
            ]
        }, */
        /* {
            'sites': [
                '/business/loesungen/unified-communications.html'
            ],
            'blacklist': [

            ],
            'stdModalId': 'uccPopup',
            'stdTriggerLink': 'eweb8.vfd2-testnet.de/business/digitalisierung/branchenloesungen.html',
            'stdHeadline': 'Whitepaper: Modernes Arbeiten in Unternehmen',
            'stdSubline': 'Mit Collaboration-Tools verpassen Sie keinen Anruf Ihrer Kunden. Und Sie ermöglichen Ihren Mitarbeitern effizientes Arbeiten im Homeoffice. Lesen Sie mehr über neue Arbeitsmodelle im Whitepaper.',
            'stdTeaser': '/simplicity/components/enterprise-popup/assets/ucc-whitepaper-popup.jpg',
            'stdDelay': 10000,
            'buttons': [
                {
                    'stdLabel': 'Zum Whitepaper Download',
                    'stdLink': 'https://eweb8.vfd2-testnet.de/business/loesungen/ucc-whitepaper.html?icmp:vbg:popup-ucc-wp_ucc',
                    'stdButtonClass': 'btn-red'
                },
            ]
        }, */
        /* {
            'sites': [
                '/business/loesungen/unified-communications-loesungen.html'
            ],
            'blacklist': [

            ],
            'stdModalId': 'uccSolutionsPopup',
            'stdTriggerLink': 'eweb8.vfd2-testnet.de/business/digitalisierung/branchenloesungen.html',
            'stdHeadline': 'Whitepaper: Modernes Arbeiten in Unternehmen',
            'stdSubline': 'Mit Collaboration-Tools verpassen Sie keinen Anruf Ihrer Kunden. Und Sie ermöglichen Ihren Mitarbeitern effizientes Arbeiten im Homeoffice. Lesen Sie mehr über neue Arbeitsmodelle im Whitepaper.',
            'stdTeaser': '/simplicity/components/enterprise-popup/assets/ucc-whitepaper-popup.jpg',
            'stdDelay': 10000,
            'buttons': [
                {
                    'stdLabel': 'Zum Whitepaper Download',
                    'stdLink': 'https://eweb8.vfd2-testnet.de/business/loesungen/ucc-whitepaper.html?icmp:vbg:popup-ucc-wp_virt',
                    'stdButtonClass': 'btn-red'
                },
            ]
        }, */
        /* {
            'sites': [
                '/business/digitalisierung.html',
                '/business/loesungen/*',
                '/business/digitalisierung/*'
            ],
            'blacklist': [
                '/business/loesungen/one-net-express.html',
                '/business/loesungen/smart-health.html',
                '/business/loesungen/unified-communications.html',
                '/business/loesungen/unified-communications-loesungen.html',
                '/business/digitalisierung/online-sessions.html'
            ],
            'stdModalId': 'iotSpotlightPopup',
            'stdTriggerLink': 'eweb8.vfd2-testnet.de/business/digitalisierung/branchenloesungen.html',
            'stdHeadline': 'Studie: Internet of Things 2020',
            'stdSubline': 'Die Welt verändert sich – und der IoT-Markt wächst. Aber wie hilft IoT jetzt den Unternehmen, sich auf die Zukunft einzustellen? Und bei der Bewältigung der COVID-19-Krise?',
            'stdTeaser': '/simplicity/components/enterprise-popup/assets/iot-spotlight-popup-652x280-dt.jpg',
            'stdDelay': 10000,
            'buttons': [
                {
                    'stdLabel': 'Zum Download',
                    'stdLink': 'https://eweb8.vfd2-testnet.de/business/loesungen/iot-spotlight-2020.html?icmp=vbg:popup:iotspotlight',
                    'stdButtonClass': 'btn-red'
                },
            ]
        }, */
    ];


    function generateTeaserModal(content) {
        var buttons = generateButtons(content.buttons);

        var modalVariationTeaser =
            '<div class="ep-modal ep-modal-popup modal fade" id="' + content.stdModalId + '" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">' +
                '<div class="modal-dialog modal-dialog-centered ep-modal__dialog" role="document">' +
                    '<div class="modal-content ep-modal__content">' +
                        '<div class="modal-header ep-modal__header">' +
                            '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                                '<span aria-hidden="true">' +
                                '<svg class="i-dialog-close-sml i-white i-sml">' +
                                        '<use xlink:href="/simplicity/svgdefs.svg#i-dialog-close-sml">' +
                                    '</svg>' +
                                '</span>' +
                            '</button>' +

                            '<img class="d-block w-100 h-auto" src="' + content.stdTeaser + '" alt="" />' +
                        '</div>' +

                        '<div class="modal-body ep-modal__body">' +
                            '<div class="row">' +
                                '<div class="col-12">' +
                                        '<h2 class="h2 w-100">' + content.stdHeadline + '</h2>' +
                                        '<h3 class="w-100">' + content.stdSubline + '</h3>' +
                                        '<div class="col-12 offset-sm-3 col-sm-6 px-0 ep-modal__buttons">' +
                                            buttons +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                        '</div>' +

                    '</div>' +
                '</div>' +
            '</div>';

        return modalVariationTeaser;
    }

    function generateButtons(buttons) {
        var buttonString = '';

        buttons.map(function(button) {
            buttonString += '<a href="' + button.stdLink + '" target="_blank" rel="noopener noreferrer" class="btn ' + button.stdButtonClass + '">' + button.stdLabel + '</a>';
            return true;
        });

        return '<div class="btn-container d-flex flex-column">' + buttonString + '</div>';
    }

    // TODO: needed for another ticket regarding the popup functionality
    var modalVariationIframe = '<div class="ep-modal ep-modal-iframe modal fade" id="iframeModal" tabindex="-1" role="dialog" aria-labelledby="iframeModal" aria-hidden="true">' +
        '<div class="modal-dialog modal-dialog-centered ep-modal__dialog col-12 col-md-6" role="document">' +
            '<div class="modal-content ep-modal__content">' +
               '<div class="modal-header ep-modal__header">' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                        '<span aria-hidden="true">' +
                            '<svg class="i-dialog-close-sml i-white i-sml">' +
                                '<use xlink:href="/simplicity/svgdefs.svg#i-dialog-close-sml">' +
                            '</svg>' +
                        '</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-body ep-modal__body">' +
                    '<iframe></iframe>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';

    function glob(pattern, input) {
        var re = new RegExp(pattern.replace(/([.?+^$[\]\\(){}|\/-])/g, '\\$1').replace(/\*/g, '.*'));
        return re.test(input);
    }

    var EXPIRE_INDICATOR = '_exp';
    function setModalExpireTimestamp(id) {
        var days = 30;
        var d = new Date();
        d.setTime(d.getTime() + (days * 24*60*60*1000));
        localStorage.setItem(id + EXPIRE_INDICATOR, d);
    }

    function isModalTimestampExpired(id) {
        var storageTimestamp = localStorage.getItem(id + EXPIRE_INDICATOR);
        if(!storageTimestamp) {
            return true;
        }
        var currentDate = new Date();
        //currentDate.setTime(currentDate.getTime() + (31 * 24*60*60*1000));
        return (currentDate.getTime() >= new Date(storageTimestamp).getTime())
    }

    function showModal(modal, id) {
        try {
            setModalExpireTimestamp(id);
            $(modal).modal('show');
        } catch (error) {
            console.warn(error);
        }
    }

    function checkAgainstArray(array, pageSlug) {
        return array && array.some(function(item) {
            return glob(item, pageSlug);
        });
    }

    function init() {
        var nodeToAppend = document.getElementById('top');
        var pageSlug = window.location.pathname;

        for (var i = 0; i < modalsToInject.length; i++) {
            var sitesToBeRegistered = modalsToInject[i].sites;
            var sitesOnBlacklist = modalsToInject[i].blacklist;

            var siteIsOnBlacklist = checkAgainstArray(sitesOnBlacklist, pageSlug);

            if(siteIsOnBlacklist) {
                return;
            }

            // if one site is matching go on and register
            var siteIsAllowed = checkAgainstArray(sitesToBeRegistered, pageSlug);

            if (siteIsAllowed) {
                var popupId = modalsToInject[i].stdModalId;
                if(!isModalTimestampExpired(popupId)) return;

                var modalTemplate = generateTeaserModal(modalsToInject[i]);
                var modalContainer = document.createElement('div');
                modalContainer.innerHTML = modalTemplate;
                nodeToAppend.appendChild(modalContainer);

                var modal = document.getElementById(popupId);
                //registerClick(modal, modalsToInject[i]);

            /* if(popupId === 'smePopup') {
                var today = new Date();
                var releaseDate = new Date('2021/7/1').setHours(14);

                if(today < releaseDate) {
                    return;
                }
            } */

                var popupDelay = modalsToInject[i].stdDelay || 0;
                setTimeout(function() {
                    showModal(modal, popupId);
                }, popupDelay);

            }

        }
    }

    return {
        'init': init
    };

})();

window.vf.enterprisePopup.init();
